module.exports = __webpack_public_path__ + "static/img/RW954-G_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RW954-G_1.png
// module id = lzJm
// module chunks = 0